const React = require('react')

const GlobalContext = React.createContext({
  alternativeTheme: null,
  breadcrumbData: {},
  templateData: {},
  isDevServer: false,
  locale: '',
  location: {},
  siteConfig: {},
})

module.exports = GlobalContext
